import { Button, Card, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { I18NextNS } from 'src/models/Language.model';

interface IOrderTaskConfirmProps {
  shouldShowConfirm: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isProcessing?: boolean;
}

const OrderTaskConfirm = ({
  shouldShowConfirm,
  isProcessing = false,
  onConfirm,
  onCancel,
}: IOrderTaskConfirmProps) => {
  const { t } = useTranslation(I18NextNS.COMMON);

  return (
    <div className="position-relative">
      {shouldShowConfirm && (
        <>
          <div
            onClick={onCancel}
            className="position-fixed top-0 start-0 w-100 h-100"
          />

          <Card
            className="position-absolute shadow-lg"
            style={{ transform: 'translate(55px, 2px)' }}
          >
            <Card.Body className="p-2 m-1">
              <Card.Title className="fs-6 fw-bold mb-0">
                {t('orderTasks.confirmTaskTitle')}
              </Card.Title>

              <p className="fs-6 m-0">{t('orderTasks.confirmTaskMessage')}</p>

              <div className="d-flex justify-content-between mt-2">
                <Button
                  variant="primary-100"
                  onClick={onCancel}
                  disabled={isProcessing}
                  size="sm"
                  className="d-flex align-items-center justify-content-center me-2"
                  style={{ width: '105px', height: '30px' }}
                >
                  {t('modal.cancel')}
                </Button>

                <Button
                  variant="primary"
                  onClick={onConfirm}
                  disabled={isProcessing}
                  size="sm"
                  className="d-flex align-items-center justify-content-center fw-normal"
                  style={{ width: '105px', height: '30px' }}
                >
                  {isProcessing ? (
                    <Spinner animation="border" size="sm" variant="light" />
                  ) : (
                    t('modal.confirm')
                  )}
                </Button>
              </div>
            </Card.Body>
          </Card>
        </>
      )}
    </div>
  );
};

export default OrderTaskConfirm;
